import { GraphQLClient } from 'graphql-request'
import { Payload } from '../types'

const GQL_URL = process.env.REACT_APP_GATEWAY_URI

const SUBMIT_CCPA_MUTATION = `mutation SubmitCcpaMutation($payload: CcpaInput!) {
  SubmitCcpa(payload: $payload)
}`

const gqlClient = new GraphQLClient(GQL_URL)

export const submitCcpaMutation = async (payload: Payload): Promise<any> => await gqlClient.request(SUBMIT_CCPA_MUTATION, { payload })

export default gqlClient
